<template>
  <div class="sidemenu">
    <router-link class="pri" :class="{ active: route.name.includes('trip') }" :to="{ name: 'trips' }"><span class="icon">&#xe900;</span>Trips</router-link>
    <div v-if="route.name.indexOf('trip') != -1" class="sec">
      <router-link :to="{ name: 'trips' }" :class="{ on: $route.name == 'trips' }">All Trips</router-link>
      <router-link :to="{ name: 'trip_new' }" :class="{ on: $route.name == 'trip_new' }">Book a Trip</router-link>
    </div>

    <template v-if="isTripAdmin || props.customFeats.isCustomReports || isChaperone">
      <router-link class="pri" :class="{ active: route.name.includes('reports') }" :to="isTripAdmin ? { name: 'reports_flights_manifest' } : isChaperone ? { name: 'reports_student_flights' } : customReportRoute(defaultCustomerReport)"><span class="icon">&#xe904;</span>Reports</router-link>
      <div v-if="route.name.indexOf('reports') != -1" class="sec">
        <router-link v-if="isTripAdmin" :to="{ name: 'reports_flights_manifest' }" :class="{ on: $route.name == 'reports_flights_manifest' }">Flight Manifest</router-link>
        <template v-if="isSuperAdmin">
          <router-link :to="{ name: 'reports_flight_volume' }" :class="{ on: $route.name == 'reports_flight_volume' }">Flight Volume</router-link>
          <router-link :to="{ name: 'reports_transactions' }" :class="{ on: $route.name == 'reports_transactions' }"> Transactions </router-link>
          <router-link :to="{ name: 'reports_travelers_costs' }" :class="{ on: $route.name == 'reports_travelers_costs' }"> Traveler Costs </router-link>
          <router-link :to="{ name: 'reports_travelers_flights' }" :class="{ on: $route.name == 'reports_travelers_flights' }">Traveler Flights</router-link>
          <router-link :to="{ name: 'reports_travelers_hotels' }" :class="{ on: $route.name == 'reports_travelers_hotels' }">Traveler Hotels</router-link>
        </template>
        <div v-if="orgCustomReports.length > 0" class="submenu">Custom Reports</div>
        <router-link v-for="r in orgCustomReports" :key="r.id" :to="customReportRoute(r.id)" :class="{ on: isCurrentCustomReport(r.id) }">{{ r.title }}</router-link>
        <router-link v-if="isChaperone" :to="{ name: 'reports_student_flights' }" :class="{ on: $route.name == 'reports_student_flights' }">Student Flights</router-link>
      </div>
    </template>

    <router-link class="pri" :class="{ active: route.name.includes('settings') }" :to="{ name: 'settings_account' }"><span class="icon">&#xe903;</span>Settings</router-link>
    <div v-if="route.name.indexOf('settings') != -1" class="sec">
      <router-link :to="{ name: 'settings_account' }" :class="{ on: $route.name == 'settings_account' }">Account</router-link>
      <router-link :to="{ name: 'settings_travelers' }" :class="{ on: $route.name == 'settings_travelers' }">Travelers</router-link>
      <router-link :to="{ name: 'settings_billing' }" :class="{ on: $route.name == 'settings_billing' }">Billing</router-link>
      <router-link v-if="isSuperAdmin" :to="{ name: 'settings_vouchers' }" :class="{ on: $route.name == 'settings_vouchers' }">Vouchers</router-link>
      <router-link v-if="isSuperAdmin" :to="{ name: 'settings_policies' }" :class="{ on: $route.name == 'settings_policies' }">Policies</router-link>
      <router-link v-if="isSuperAdmin" :to="{ name: 'settings_team' }" :class="{ on: $route.name == 'settings_team' }">Team</router-link>
    </div>

    <a class="pri" @click="signout"><span class="icon">&#xe902;</span>Sign Out</a>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useRoute } from "vue-router";
import useApi from "../utils/apiCalls";

const emit = defineEmits(["error"]);
const props = defineProps(["organizations", "customFeats"]);

const route = useRoute();
const { apiGetRequest } = useApi(emit);
const orgCustomReports = ref([]);
const defaultCustomerReport = ref(4); //HSSA FLIGHTS

const isTripAdmin = computed(() => {
  return props.organizations.filter(org => org.user_type >= 1).length >= 1;
});

const isSuperAdmin = computed(() => {
  return props.organizations.filter(org => org.user_type === 1).length >= 1;
});

const isChaperone = computed(() => !!props.customFeats.isChaperoneReports);

if (props.customFeats.isCustomReports) {
  apiGetRequest({
    path: `/reports/custom`,
    onSuccess: data => {
      orgCustomReports.value = data;
      if (data.length > 0 && !data.find(r => r.id == defaultCustomerReport.value)) defaultCustomerReport.value = data[0].id;
    },
  });
}

const signout = () => {
  document.cookie = "jwt=null;domain=" + import.meta.env.VITE_APP_FLIGHTFOX_COOKIE_DOM + ";expires=Thu, 01 Jan 1970 00:00:00 GMT";
  let url = import.meta.env.VITE_APP_FLIGHTFOX_APP_CUSTOMER_URL + "/login?signout=true";
  window.location.replace(url);
};

const customReportRoute = reportId => {
  if (reportId === 1) return { name: "reports_custom_users" };
  if (reportId === 4) return { name: "reports_custom_flights" };
  if (reportId === 5) return { name: "reports_custom_volume" };

  return {
    name: "reports_custom",
    params: { reportId: reportId },
  };
};

const isCurrentCustomReport = reportId => {
  const r = customReportRoute(reportId);

  if (r.params === void 0) return route.name === r.name;

  return route.name === r.name && route.params.reportId == r.params.reportId;
};
</script>
